import { range } from 'ramda';
import { useCallback, useState } from 'react';
import { getRangeToLoad } from './getRangeToLoad';
export const useRangesWindowAndConstrain = () => {
    const [log, setLog] = useState(new Set());
    const clearLog = useCallback(() => setLog(new Set()), []);
    const logRange = useCallback((offset, limit) => setLog((oldLog) => new Set([...oldLog, ...range(offset, offset + limit)])), []);
    const getRange = useCallback((offset, limit, maxOffset = Number.MAX_SAFE_INTEGER) => {
        const pageSize = Math.max(limit, 10);
        const rangeToLoad = getRangeToLoad(offset, Math.min(maxOffset, offset + limit), pageSize, log);
        if (!rangeToLoad) {
            return;
        }
        logRange(rangeToLoad.offset, rangeToLoad.pageSize);
        return rangeToLoad;
    }, [log, logRange]);
    return { getRange, reset: clearLog };
};
//# sourceMappingURL=useRangesWindowAndConstrain.js.map